import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
import { removeUnderscores } from "utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { DeviationApprovalData } from "assets/properties/properties";

const DeviationMasterApproval = ({ seletedBranchCode }) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const location = useLocation();
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [branchCodeList, setBranchCodeList] = useState([]);
  const [status, setStatus] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    if (location.state?.toastMessage) {
      toastUpdate(location.state.toastType, location.state.toastMessage, true);
  
      setTimeout(() => {
        navigate(location.pathname, { replace: true, state: {} });
      }, 100);
    }
  }, [location.key]);
  useEffect(() => {
      getAllBranchDetails();
    }, []);
    const getAllBranchDetails = async () => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.FIND_ALL_BRANCH,
        authToken: authToken,
      });
      setCallInProgress(false);
      if (!result?.data?.error_code) {
        setBranchCodeList(result?.data);
        GetData(result?.data);
      }
    };

  const GetData = async (branchList) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.DEVIATION_SEARCH + "?status=ENTERED",
      authToken: authToken,
      method: "GET",
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      parseIndicatorData(result?.data, branchList);
    }
  };

  const parseIndicatorData = (data, branchList) => {
    let reportData = [];
    data = data?.sort((a, b) => (a.id < b.id ? 1 : -1));
     const matchBranchName = (branchCode) => {
    const branch = branchList.find((branch) => branch.code === branchCode);
      return branch ? branch.name : branchCode;
    }
    data &&
      data.forEach((ForApprovalApplication, index) => {
        let row = {
          id: ForApprovalApplication?.id,
          leadId: ForApprovalApplication?.loanApplicationId,
          sender: ForApprovalApplication?.makerUsername,
          loanAccountNumber: ForApprovalApplication?.loanAccountNumber,
          customerId: ForApprovalApplication?.customerId,
          customerName: ForApprovalApplication?.customerName,
          loanAmount: ForApprovalApplication?.loanAmount,
          applicationType: `${ForApprovalApplication?.applicationType}/${ForApprovalApplication?.applicationSubType}`,
          branchCode: matchBranchName(ForApprovalApplication?.branchCode),
          status: ForApprovalApplication?.status,
          deviationJson: ForApprovalApplication?.deviationJson,
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const onClickUpdateData = async (
    loanApplicationId,
    deviationId,
    deviationJson
  ) => {
    const result = await apiHandler({
      url: endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}`,
      authToken: authToken,
    });
    setStatus(DeviationApprovalData?.statusCode);
    const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
      const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]
    const navigationData = {
      showModal: false,
      loanApplicationId,
      subStatus: result?.data.applicationSubType || "",
      status: DeviationApprovalData?.statusCode,
      prePledgeLoan: prepledgeLoanAccountNumber || "",
      editable: false,
      seletedBranchCode,
      deviationId,
      deviationJson,
    };
    navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label={headerLabel?.deviationApproval} onlyLabel />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={DeviationApprovalData?.tableColumns}
          rows={selectedTableData}
          onClickUpdateData={onClickUpdateData}
          flag="deviation"
        />
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

DeviationMasterApproval.propTypes = {
  classes: PropTypes.object,
};

export default DeviationMasterApproval;
